import clsx from "clsx"
import { useEffect, useState } from "react"
import GreekHero from "@/components/GreekHero"
import { diSanaStores } from "@/app/utils/constants"
import { Link } from "react-router-dom"
import "@/assets/css/slider.css"
import { useGlobalContext } from "@/global/GlobalContext"

const DiSanaHero = ({ children }) => {
  const { isToggled, categories, setCategories, finishToggled, onReqDiSana } = useGlobalContext()
  const [sideMenus, setSideMenus] = useState([])

  useEffect(() => {
    if (categories.length > 0) {
      const updatedCategories = [
        ...categories,
        {
          name: "Loro Blonyo Fine Porcelain",
          slug: "loro-blonyo-fine-porcelain",
          photo: "",
        },
      ]

      setSideMenus(updatedCategories)
    }
  }, [categories])

  return (
    <>
      <GreekHero>
        <div className="h-[calc(100vh-16px)] w-full bg-[url('/src/assets/imgs/head-silhouette.png')] bg-cover no-repeat object-cover flex">
          <aside id="aside" className={clsx("w-full sm:w-2/5 max-sm:px-6 sm:pl-12 mt-5 relative top-14 sm:top-16", { "z-30": !isToggled && finishToggled, "z-10": isToggled })}>
            <div>
              <span className="uppercase font-agcasmlt text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#6b6059]">store</span>
              <ul>
                {onReqDiSana ?
                  <div>
                    {Array.from({ length: 14 }, (_, i) => (
                      <div key={i} className="animate-shimmer transition-opacity w-1/3 h-[14px] sm:h-5 mb-1"></div>
                    ))}
                  </div>
                  :
                  <>
                    {sideMenus.length > 0 &&
                      sideMenus.map((s, i) => (
                        <li key={i} className={clsx("max-sm:mt-1 block font-agcasmlt font-light text-sm sm:text-xl", { "mb-5": i == 10, "mt-2": i == 0 })}>
                          <Link to={`/di-sana/${s.slug}`}>{s.name}</Link>
                        </li>
                      ))
                    }
                    {diSanaStores.map((s, i) => (
                      <li key={i} className={clsx("max-sm:mt-1 block font-agcasmlt font-light text-sm sm:text-xl", { "mb-5": i == 10, "mt-2": i == 0 })}>
                        <Link to={s.link}>{s.title}</Link>
                      </li>
                    ))}
                  </>
                }
              </ul>
            </div>
          </aside>
          <div className="max-sm:hidden sm:w-3/5 flex justify-center my-auto">
            <div className="w-[90%] lg:w-2/3">
              <h1 className="text-[#95702e] font-light sm:text-4xl md:text-5xl lg:text-6xl"><span className="uppercase font-agcasmlt mr-6">di sana</span><span className="font-sloopScriptPro">Our Shop & Cafe</span></h1>
              <div className="">
                <p className="font-agcasmlt text-[#6b6059] text-justify text-sm sm:text-xl font-light"><span className="font-sloopScriptPro font-extrabold text-lg sm:text-xl lg:text-2xl">W</span>e want you to experience and enjoy the aesthetic details and beauty of the West, not only in terms of textures, objects, patterns, ambiance, and services, but also as a fusion of the richness of both the East and West.</p>
                <br />
                <p className="font-agcasmlt text-[#6b6059] text-justify text-sm sm:text-xl font-light"><span className="font-sloopScriptPro font-extrabold text-lg sm:text-xl lg:text-2xl">T</span>hrough DI SANA, we aim to share our love for hospitality, high-quality products, well-made items, and our passion for the luxurious world of classic, top-quality crafts that Jonathan Rachman understands and celebrates at his core.</p>
              </div>
              {children}
            </div>
          </div>
        </div>
      </GreekHero>
      <div className="flex justify-center sm:hidden w-3/4 mx-auto">
        <div className="">
          <h1 className="text-[#95702e] font-light text-3xl text-center"><span className="uppercase font-agcasmlt mr-3 sm:mr-6">di sana</span><span className="font-sloopScriptPro">Our Shop & Cafe</span></h1>
          <div className="mt-1">
            <p className="font-agcasmlt text-[#6b6059] text-center text-sm sm:text-xl font-light"><span className="font-sloopScriptPro font-extrabold text-lg sm:text-xl lg:text-2xl">W</span>e want you to experience and enjoy the aesthetic details and beauty of the West, not only in terms of textures, objects, patterns, ambiance, and services, but also as a fusion of the richness of both the East and West.</p>
            <br />
            <p className="font-agcasmlt text-[#6b6059] text-center text-sm sm:text-xl font-light"><span className="font-sloopScriptPro font-extrabold text-lg sm:text-xl lg:text-2xl">T</span>hrough DI SANA, we aim to share our love for hospitality, high-quality products, well-made items, and our passion for the luxurious world of classic, top-quality crafts that Jonathan Rachman understands and celebrates at his core.</p>
          </div>
          {children}
        </div>
      </div>
    </>
  )
}

export default DiSanaHero